'use client';
import React from 'react';
import { StockSymbol, UnixTimestamp } from '@benzinga/session';
import styled, { ThemeNames } from '@benzinga/themetron';
import { Popover } from 'antd';
import { ProTicker as Ticker, TickerColor } from '../../components/Ticker';
import { useQuoteSubscription } from '@benzinga/quotes-manager-hooks';

export interface CashTagPopoverProps {
  exchangeSymbol: string;
  onSymbolClick: (symbol: StockSymbol) => void;
  referenceTime?: UnixTimestamp;
  theme?: ThemeNames;
}

const extractSymbol = (exchangeSymbol: string) => {
  const symbolStart = exchangeSymbol?.toUpperCase().indexOf(':');
  return symbolStart === -1 ? exchangeSymbol : exchangeSymbol.slice(symbolStart + 1);
};

export const CashtagPopover: React.FC<CashTagPopoverProps> = props => {
  const [isTickerValid, setTickerValid] = React.useState<boolean>(false);
  const [tickerForceOpen, setTickerForceOpen] = React.useState<boolean>(false);

  const { quote } = useQuoteSubscription(props.exchangeSymbol);

  React.useEffect(() => {
    if (quote) {
      setTickerValid(true);
    }
  }, [quote]);

  const onDialogModeChange = (isTickerForceOpen: boolean) => {
    setTickerForceOpen(isTickerForceOpen);
  };

  const { exchangeSymbol, referenceTime, theme } = props;
  const symbol = extractSymbol(exchangeSymbol);

  const content = (
    <div className="TickerPopover">
      <Ticker
        isOnlySymbol
        modules={{ chart: { referenceTime } }}
        onDialogModeChange={onDialogModeChange}
        onSymbolClick={props.onSymbolClick}
        symbol={symbol}
      />
    </div>
  );

  if (!isTickerValid) {
    return <span>${props.exchangeSymbol}</span>;
  }

  // hacks on hacks i don't know why i could not simply set visible to undefined
  if (tickerForceOpen) {
    return (
      <Popover
        content={content}
        overlayClassName={`bz-theme-${theme} u-antdPopoverReset`}
        placement="rightTop"
        trigger="hover"
        visible
      >
        <TickerText>
          <TickerColor onSymbolClick={props.onSymbolClick} symbol={symbol} symbolLabel={`$${exchangeSymbol}`} />
        </TickerText>
      </Popover>
    );
  } else {
    return (
      <Popover
        content={content}
        overlayClassName={`bz-theme-${theme} u-antdPopoverReset`}
        placement="rightTop"
        trigger="hover"
      >
        <TickerText>
          <TickerColor onSymbolClick={props.onSymbolClick} symbol={symbol} symbolLabel={`$${exchangeSymbol}`} />
        </TickerText>
      </Popover>
    );
  }
};

const TickerText = styled.div`
  cursor: pointer;
  display: inline-block;
`;
